import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { IntroPage } from "../components/IntroPage";
import { ModuleBoard } from "../components/ModuleBoard";
import { Calculator } from "../components/Calculator";
import { Reveal } from "../components/NoteBlocks";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <IntroPage />
      <ModuleBoard />
      <section id="calculator" className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="calculator-section">
        <Reveal>
          <p className="eyebrow">Try it yourself</p>
          <h2 className="font-display text-6xl sm:text-7xl text-[#1F2A44] mt-3 leading-[0.9]">Is your ad actually making money?</h2>
          <p className="text-base md:text-lg text-[#4A4A55] max-w-xl mt-4 mb-12">Put in your numbers. ROAS, CPA and break-even ROAS update as you type.</p>
        </Reveal>
        <Calculator />
      </section>
    </main>
  );
}
